import React, {Component} from 'react';
import {withTranslate} from 'react-redux-multilingual'
import {TbBrandFacebook, TbBrandInstagram, TbBrandTelegram, TbBrandWhatsapp} from 'react-icons/tb';
import './footer.scss';
import ContactForm from "../contact-form/contact-form";
import contacts, {telegramHref, whatsappHref} from "../../../constants/contacts";


class FooterOne extends Component {

    render() {
        const {translate} = this.props;
        return (
            <footer className="cpr-footer">
                <div className="cpr-container">
                    <div className="cpr-footer__grid">
                        <div className="cpr-footer__intro">
                            <p className="cpr-footer__kicker cpr-sentence">{translate('are_you_interested')}</p>
                            <h2 className="cpr-h2 cpr-sentence">
                                {translate('its_time_to_discover')} {translate('the_building')}
                            </h2>

                            <dl className="cpr-footer__contacts">
                                <div>
                                    <dt className="cpr-label">{translate('office_location_label')}</dt>
                                    <dd>{translate('office_location_info')}</dd>
                                </div>
                                <div>
                                    <dt className="cpr-label">{translate('phone')}</dt>
                                    <dd className="cpr-num">
                                        <a href={contacts.phone.href}>{contacts.phone.display}</a><br/>
                                        <a href={contacts.phoneOffice.href}>{contacts.phoneOffice.display}</a>
                                    </dd>
                                </div>
                                <div>
                                    <dt className="cpr-label">{translate('email')}</dt>
                                    <dd>
                                        <a href={`mailto:${contacts.emailSales}`}>{contacts.emailSales}</a><br/>
                                        <a href={`mailto:${contacts.emailMarketing}`}>{contacts.emailMarketing}</a>
                                    </dd>
                                </div>
                                <div>
                                    <dt className="cpr-label">{translate('contact_agent')}</dt>
                                    <dd>
                                        {translate('operator_name')}
                                        <span className="cpr-footer__role cpr-sentence">{translate('sales_agent')}</span>
                                    </dd>
                                </div>
                            </dl>
                        </div>

                        <div className="cpr-footer__form" id="contact">
                            <h3 className="cpr-h3 cpr-sentence">{translate('enquire')}</h3>
                            <ContactForm onClose={() => {}}/>
                        </div>
                    </div>

                    <div className="cpr-footer__bottom">
                        <p>© {new Date().getFullYear()} City Premium Realty. {translate('all_rights_reserved')}.</p>
                        <div className="cpr-footer__social">
                            {whatsappHref &&
                                <a href={whatsappHref} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                                    <TbBrandWhatsapp aria-hidden="true"/>
                                </a>}
                            {telegramHref &&
                                <a href={telegramHref} target="_blank" rel="noopener noreferrer" aria-label="Telegram">
                                    <TbBrandTelegram aria-hidden="true"/>
                                </a>}
                            <a href={contacts.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <TbBrandFacebook aria-hidden="true"/>
                            </a>
                            <a href={contacts.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <TbBrandInstagram aria-hidden="true"/>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}


export default withTranslate(FooterOne);
